var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"root",staticClass:"top-button",attrs:{"href":"#top"}},[_vm._v("nach oben")])}
var staticRenderFns = []

export { render, staticRenderFns }